import { html, ovl, SYSAction } from "../../../../../../../_ovlclient/src"
import { SortGet } from "../../../../../../../_ovlclient/src/global/globalapi"
import {
  HookFieldGetEditHint_ReturnType,
  HookFieldGetEditHint_Type,
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFieldGetValueRender_ReturnType,
  HookFieldGetValueRender_Type,
  HookFormChanged_Type,
  HookFormInit_Type,
  HookFormValidate_Type,
} from "../../../../../../../_ovlclient/src/global/hooks"
import {
  FieldIsValid,
  FieldSetFocus,
  FieldSetState,
  FieldSetVal,
  FieldVal,
  SYSFormState,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import { ValidationsAdd } from "../../../../../../../_ovlclient/src/library/forms/validatorsapi"
import { NewServiceStep1FormFieldKeys } from "./formdef"
import { dateDiffInDays, FindSlots } from "./helpers"

const HookFormValidate: SYSAction<HookFormValidate_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  let fieldKey = <NewServiceStep1FormFieldKeys>value.field.fieldKey
  let field = value.formState.fields[fieldKey]
  switch (fieldKey) {
    case "requesterEmail":
      value.validatorUse("Mandatory")

      if (FieldIsValid(field)) {
        value.validatorUse("Email")
      }

      break
    case "planningStartDate":
      if (!value.validatorCheck("Mandatory")) {
        value.validatorUse("NotBeforeToday")
        value.validatorUse("NotLaterThanDaysFromToday", { val: 14 })
      }
      break
    case "promoCode2":
      if (FieldIsValid(field) && field.value && field.value.length === 4) {
        //document.getElementById("NewServiceStep1promoCode3").focus()
        FieldSetFocus(value.formState.fields["promoCode3"])
      }
      break
    case "promoCode3":
      value.validatorUse("IntegerRange", { val: { min: 3001, max: 3500 } })
      if (FieldIsValid(field) && field.value && field.value.length === 4) {
        //SetFocus("NewServiceStep1planningStartDate")
        FieldSetFocus(value.formState.fields["planningStartDate"])
      }
      break
    case "requesterPhone":
      value.validatorUse("Mandatory")
      if (FieldIsValid(field)) {
        let matches = value.newValue.toString().match(/\d+/g)
        let parsed
        let valid = true
        if (matches && matches.length > 0) {
          parsed = matches.join("")
          if (parsed.length < 10) {
            valid = false
          }
        } else {
          valid = false
        }
        if (!valid) {
          value.validationsAdd("NewServiceValidationInvalidPhone")
        }
      }
      break
  }
}

const HookField_problemType_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = ({ formState }, { global }) => {
  let state = global.getState()
  let problemTypeLookup = state.app.global.SVL.lookups.problemType

  if (!formState) {
    // its not from form s just return the def including the list
    return problemTypeLookup
  } else {
    // we are using the form. so filter the values

    let list = problemTypeLookup.data
    let data = {}
    Object.keys(list)
      .filter((f) => {
        return (
          !formState.fields.group.convertedValue ||
          list[f]["Group"] === formState.fields.group.convertedValue
        )
      })
      .reduce((val, m) => {
        val[m] = list[m]
        return val
      }, data)
    return {
      data,
      lookupDef: problemTypeLookup.lookupDef,
      sortFn: (dataA, dataB) => SortGet(dataA.ProblemDesc, dataB.ProblemDesc),
    }
  }
}

const HookField_group_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  return state.app.global.SVL.lookups.group
}

const HookField_planningSlots_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  return state.app.global.SVL.NewService.slotFinder.slots
}

const HookFormInit: SYSAction<HookFormInit_Type> = (
  { formState },
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  if (formState.firstInitOrSituationChanged) {
    FieldSetState(formState.fields["planningStartDate"], false, {
      mode: "visible/readonly",
      keepValidation: true,
      forceValueWhenInactive: null,
    })

    if (!FieldVal(formState.fields["group"])) {
      FieldSetVal(formState.fields["group"], "Service")
    }
  }
}

const HookFormChanged: SYSAction<HookFormChanged_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  //debugger
  if (value.initiatedByFormInit) {
    return
  }
  let changedField = value.changedField
  // if (
  //   changedField.field.fieldKey === "planningStartDate" &&
  //   changedField.isValid
  // ) {
  //   FieldSetState(value.formState.fields["planningSlots"], false, {
  //     animate: "fade",
  //     forceValueWhenInactive: undefined,
  //     keepValidation: true,
  //   })
  // }
  if (changedField.field.fieldKey === "problemType") {
    if (changedField.isValid) {
      SetPromoCodeVisibility(value.formState)
    }
    if (!changedField.isValid) {
      FieldSetState(value.formState.fields["planningStartDate"], false, {
        forceValueWhenInactive: null,
        keepValidation: true,
        mode: "visible/readonly",
      })
    } else {
      state.app.global.SVL.NewService.selectedProblemType =
        changedField.newValue
      FieldSetState(value.formState.fields["planningStartDate"], true)
    }
    FieldSetState(value.formState.fields["planningSlots"], false, {
      forceValue: null,
      keepValidation: true,
    })
  }

  if (changedField.validValueChanged && changedField.isValid) {
    {
      if (changedField.field.fieldKey === "group") {
        FieldSetVal(value.formState.fields["problemType"], null)
      } else if (
        ((changedField.field.fieldKey === "planningStartDate" &&
          FieldIsValid(value.fields["problemType"])) ||
          (changedField.field.fieldKey === "problemType" &&
            FieldIsValid(value.fields["planningStartDate"]))) &&
        FieldVal(value.fields["planningStartDate"])
      ) {
        FieldSetState(value.formState.fields["planningSlots"], false, {
          forceValue: null,
          keepValidation: true,
        })
        try {
          await FindSlots(state, actions, value.formState)
        } catch {
          // new 20250505, if exception during api call then reset field
          value.setCorrectedValue(null)
        }
      } else if (changedField.field.fieldKey === "planningSlots") {
        state.app.global.SVL.NewService.selectedSlot = changedField.newValue
      }
    }
  }
}

// const HookField_planningStartDate_GetEditHint: SYSAction<
//   HookFieldGetEditHint_Type,
//   HookFieldGetEditHint_ReturnType
// > = (value, { global }) => {
//   let state = global.getState()

//   if (value.row["planningStartDate"]) {
//     let dval = new Date(value.row["planningStartDate"].toString())
//     let prefix = ""
//     let today = new Date()
//     if (dateDiffInDays(today, dval) < 1) {
//       prefix = "Heute "
//     }
//     return (
//       prefix +
//       dval.toLocaleString("default", {
//         weekday: "long",
//       })
//     )
//   }
// }
export const SetPromoCodeVisibility = (formState: SYSFormState) => {
  let res = false
  let problemTypeField = formState.fields["problemType"]

  let problemType = FieldVal(problemTypeField)

  res =
    problemType &&
    ovl
      .getState()
      .app.global.SVL.lookups.problemType.data[problemType][
        "ProblemDesc"
      ].toLowerCase()
      .indexOf("promo") > -1
  FieldSetState(formState.fields["promoCode"], res, {
    mode: "readonly/notvisible",
  })
  FieldSetState(formState.fields["promoCode2"], res, { focusWhenVisible: true })
  FieldSetState(formState.fields["promoCode3"], res)

  ovl.getState().app.global.SVL.NewService.promo.visible = res
}

export let hooks = {
  HookFormValidate,
  HookField_problemType_GetList,
  HookField_group_GetList,
  HookField_planningSlots_GetList,
  HookFormInit,
  HookFormChanged,
  //HookField_planningStartDate_GetEditHint,
}
